import { render, staticRenderFns } from "./AsideUpdatesItem.vue?vue&type=template&id=e537ee82"
import script from "./AsideUpdatesItem.vue?vue&type=script&lang=js"
export * from "./AsideUpdatesItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports